import styled from "styled-components";

export const UserInfoBox = styled.div`
  gap: 20px;
  width: 100%;
  display: flex;
  padding-bottom: 16px;
  flex-direction: column;
`;

export const UserLinkedBox = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;

  svg {
    z-index: 1;
  }

  &::after {
    width: 100%;
    z-index: 0;
    content: "";
    position: absolute;
    border-top: 1px solid ${(props) => props.theme.colors.black5};
  }
`;

export const UserInfo = styled.div`
  gap: 20px;
  width: 100%;
  display: flex;
  align-items: center;
`;

export const UserInfoImg = styled.div`
  width: 60px;
  height: 60px;
  display: flex;
  background: ${(props) => props.theme.colors.black10};
  flex-shrink: 0;
  align-items: center;
  border-radius: 8px;
  justify-content: center;
`;

export const UserTextBox = styled.div`
  gap: 6px;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const UserTypeTxt = styled.div`
  width: 100%;
  color: ${(props) => props.theme.colors.primary100};
  display: flex;
  font-size: 1.2rem;
  font-weight: 700;
  white-space: nowrap;
  align-items: center;
  justify-content: space-between;

  span {
    color: ${(props) => props.theme.colors.inputPlaceholder};
    font-size: 1rem;
    text-align: right;
    font-weight: 400;
    white-space: wrap;
  }
`;

export const UserNameTxt = styled.div`
  gap: 6px;
  width: 100%;
  display: flex;
  font-size: 2rem;
  font-weight: 800;
  align-items: center;

  span {
    color: ${(props) => props.theme.colors.black60};
    font-size: 1.6rem;
    font-weight: 400;
  }
`;
